
export const RegularContainerSVG =
    ({
         fillColor = '#4acb5c',
         borderColor = '#048658',
         contrastColor = '#8ab8a8',
         width = 33.506,
         height = 40
     }) => {
        const viewBox = '0 0 40 40';
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                viewBox={viewBox}
            >
                <g id="plastic" transform="translate(2 0.5)">
                    <path
                        id="Trazado_24"
                        data-name="Trazado 24"
                        d="M62.159,188.977H39.342a1.735,1.735,0,0,1-1.725-1.553l-2.7-25.515H66.583l-2.7,25.515A1.735,1.735,0,0,1,62.159,188.977Zm0,0"
                        transform="translate(-32.213 -149.367)"
                        fill={fillColor}
                        stroke={borderColor}
                        strokeWidth="1"
                    />
                    <path
                        id="Trazado_26"
                        data-name="Trazado 26"
                        d="M65.18,10.454H33.258V4.894A4.894,4.894,0,0,1,38.152,0H60.286A4.894,4.894,0,0,1,65.18,4.894Zm0,0"
                        transform="translate(-30.681)"
                        fill={fillColor}
                        stroke={borderColor}
                        strokeWidth="1"
                    />
                    <path
                        id="Trazado_28"
                        data-name="Trazado 28"
                        d="M35,137.354H1.716a1.716,1.716,0,0,1,0-3.432H35a1.716,1.716,0,0,1,0,3.432Zm0,0"
                        transform="translate(0 -123.547)"
                        fill={contrastColor}
                        stroke={borderColor}
                        strokeWidth="1"
                    />
                    <path
                        id="Trazado_30"
                        data-name="Trazado 30"
                        d="M140.866,80.7H122.82V77.861a1.627,1.627,0,0,1,1.627-1.627h14.791a1.627,1.627,0,0,1,1.627,1.627Zm0,0"
                        transform="translate(-113.306 -70.329)"
                        fill={contrastColor}
                        stroke={borderColor}
                        strokeWidth="1"
                    />
                </g>
            </svg>
        );
    };